import React, { Component } from 'react';
import { Data } from 'react-data-grid-addons';

import Core from './../../Core/Core';
import ErrorManager from './../../Core/ErrorManager';

const selectors = Data.Selectors;

//Tri
export function sortRows(rows, sortColumn, sortDirection) {
  const comparer = (a, b) => {
    if (sortDirection === 'ASC') {
      return a[sortColumn] > b[sortColumn] ? 1 : -1;
    } else if (sortDirection === 'DESC') {
      return a[sortColumn] < b[sortColumn] ? 1 : -1;
    }
  };
  return sortDirection === 'NONE' ? rows : [...rows].sort(comparer);
}

//Nécessaire au filtrage
export function getRows(rows, filters) {
  return selectors.getRows({ rows, filters });
}

//Filtrage basique
export function handleFilterChange(filter, filters) {
  const newFilters = { ...filters };
  if (filter.filterTerm) {
    newFilters[filter.column.key] = filter;
  } else {
    delete newFilters[filter.column.key];
  }
  return newFilters;
}

//Filtrage liste prédéfinie
export function getValidFilterValues(rows, columnId) {
  let valid = rows
    .map((r) => r[columnId])
    .filter((item, i, a) => {
      if (item) {
        return i === a.indexOf(item);
      }
    });
  return valid.sort();
}

//Supression d'une ligne
function deleteRow(Proposal_id) {
  Core.Instance.Request(Core.Address + 'Proposal/' + Proposal_id, null, 'DELETE').then((json) => {
    ErrorManager.Instance.Info("L'élément a bien été supprimé.");
    window.location.reload();
  });
}

//Icones Edit et Suppression
export function getCellActions(column, row, loadProposal) {
  const cellActions = {
    actions: [
      {
        icon: <span className='far fa-trash-alt' />,
        callback: () => {
          deleteRow(row.id);
        },
      },
      {
        icon: <span className='fas fa-edit' />,
        callback: () => {
          loadProposal(row.id);
        },
      }
    ],
  };
  return cellActions[column.key];
}



// WEBPACK FOOTER //
// ./src/Components/Proposal/GridManager.js